import React, { useEffect, useState } from "react";
import {
  Menu,
  MenuItem,
  IconButton,
  Box,
  Typography,
  Divider,
  ListItemText,
  ListItem,
  List,
  Badge,
  Popover,
  Tooltip,
  ListItemIcon,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { disconnectSocket } from "../../socket/socketClient";
import { useNavigate } from "react-router-dom";
import { fontSize } from "../theme/fontSize";
import { FontFamily } from "../theme/fontFamily";
import { fontWeight } from "../theme/fontWeight";
import { ThemeColor } from "../theme/color";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import {
  GetAllNotification,
  GetUnseenNotificationCount,
} from "../../Redux/action/NotificationAction";
import { useDispatch, useSelector } from "react-redux";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { MarkNotificationSeenAPI } from "../../Redux/service/notificationService";
import "./profile.css";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [AllNotification, setAllNotification] = useState([]);
  const [UnseenNotification, setUnseenNotification] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);

  const userName = window.sessionStorage.getItem("user_name");

  useEffect(() => {
    dispatch(GetUnseenNotificationCount());
  }, []);

  const UnseenNotificationlistState = useSelector(
    (state) =>
      state.notification?.GetUnseenNotificationCount?.data?.data
        ?.totalUnseenCount
  );

  useEffect(() => {
    setUnseenNotification(UnseenNotificationlistState);
  }, [UnseenNotificationlistState]);

  const NotificationlistState = useSelector(
    (state) => state.notification?.allNotification?.data?.data
  );

  useEffect(() => {
    setAllNotification(NotificationlistState);
  }, [NotificationlistState]);

  useEffect(() => {
    dispatch(GetAllNotification());
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Closes the websocket and wipes this user's cached API data.
    disconnectSocket();
    sessionStorage.removeItem("user_token");
    sessionStorage.removeItem("ms_auth");
    sessionStorage.removeItem("ms_auth_skipped");
    navigate("/");
    navigate(0);
    handleClose();
  };

  const handleMarkNotificationSeen = async (id) => {
    await MarkNotificationSeenAPI(id)
      .then((res) => {
        if (res.status === 200) {
          dispatch(GetUnseenNotificationCount());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 0, sm: 0.5 },
        px: { xs: 0.5, sm: 1 },
        py: 0.5,
        maxWidth: { xs: 120, sm: 240, md: 280 },
      }}
    >
      <Box
        onClick={handleClick}
        aria-controls="profile-menu"
        aria-haspopup="true"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          minWidth: 0,
          px: { xs: 0.5, sm: 1 },
          py: 0.5,
          borderRadius: "999px",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.14)" },
        }}
      >
        <Typography
          noWrap
          fontSize={fontSize.h3.small}
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W500}
          color={ThemeColor.WHITE}
          sx={{ display: { xs: "none", sm: "block" }, maxWidth: 130 }}
        >
          {userName}
        </Typography>
        <AccountCircleIcon
          sx={{ fill: "white", fontSize: { xs: 26, sm: 30 } }}
        />
      </Box>

      <Tooltip title="Notifications">
        <IconButton
          onClick={(e) => setNotificationAnchorEl(e.currentTarget)}
          sx={{ p: { xs: 0.5, sm: 1 } }}
        >
          <Badge
            badgeContent={UnseenNotification || 0}
            color="error"
            max={99}
            invisible={!UnseenNotification}
          >
            <CircleNotificationsIcon
              sx={{ fill: "white", fontSize: { xs: 26, sm: 30 } }}
            />
          </Badge>
        </IconButton>
      </Tooltip>

      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              minWidth: 200,
              borderRadius: "12px",
              boxShadow: "0 12px 32px rgba(16,24,40,0.16)",
            },
          },
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography
            sx={{ fontSize: 13, color: "#667085" }}
            className="text-truncate"
          >
            Signed in as
          </Typography>
          <Typography
            noWrap
            sx={{ fontSize: 14, fontWeight: 600, color: "#101828" }}
          >
            {userName}
          </Typography>
        </Box>
        <Divider />
        <MenuItem
          onClick={() => {
            handleClose();
            navigate("/CAE/AllNotification");
          }}
        >
          <ListItemIcon>
            <NotificationsNoneIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
            Notifications
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
            Log out
          </ListItemText>
        </MenuItem>
      </Menu>

      <Popover
        open={Boolean(notificationAnchorEl)}
        anchorEl={notificationAnchorEl}
        onClose={() => setNotificationAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        marginThreshold={12}
        slotProps={{
          paper: {
            className: "notification-panel",
            sx: {
              mt: 1,
              width: { xs: "calc(100vw - 24px)", sm: 340 },
              maxWidth: 360,
            },
          },
        }}
      >
        <Box className="panel-header">
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
            Notifications
          </Typography>
          {UnseenNotification ? (
            <Typography sx={{ fontSize: 12, opacity: 0.85 }}>
              {UnseenNotification} unread
            </Typography>
          ) : null}
        </Box>

        <Box className="panel-body">
          {AllNotification?.length > 0 ? (
            <List sx={{ p: 0 }}>
              {AllNotification.slice(0, 5).map((data, index) => (
                <React.Fragment key={data._id || index}>
                  <ListItem
                    onClick={() => {
                      setNotificationAnchorEl(null);
                      handleMarkNotificationSeen(data._id);
                      navigate("/CAE/AllNotification");
                    }}
                    alignItems="flex-start"
                    sx={{
                      cursor: "pointer",
                      px: 1.5,
                      py: 1.25,
                      backgroundColor:
                        data?.isView === false ? "#EFF6FF" : ThemeColor.WHITE,
                      "&:hover": { backgroundColor: "#F1F5FB" },
                    }}
                  >
                    <ListItemText
                      primary={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              flex: 1,
                              minWidth: 0,
                              fontSize: 13.5,
                              fontWeight: data?.isView === false ? 600 : 500,
                              color: "#101828",
                              wordBreak: "break-word",
                            }}
                          >
                            {data.title}
                          </Typography>
                          {data?.isView === false && (
                            <Box
                              sx={{
                                mt: "6px",
                                flexShrink: 0,
                                backgroundColor: ThemeColor.RED,
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                              }}
                            />
                          )}
                        </Box>
                      }
                      secondary={
                        <Typography
                          sx={{ fontSize: 12, color: "#667085", mt: 0.25 }}
                        >
                          {data.isPublic ? "Global" : "Personal"}
                        </Typography>
                      }
                    />
                  </ListItem>
                  <Divider component="li" />
                </React.Fragment>
              ))}
            </List>
          ) : (
            <Box sx={{ py: 4, textAlign: "center", color: "#667085" }}>
              <NotificationsNoneIcon sx={{ fontSize: 34, opacity: 0.5 }} />
              <Typography sx={{ fontSize: 13, mt: 1 }}>
                No notifications yet
              </Typography>
            </Box>
          )}
        </Box>

        <Divider />
        <Box
          className="view-all"
          onClick={() => {
            setNotificationAnchorEl(null);
            navigate("/CAE/AllNotification");
          }}
        >
          View All
        </Box>
      </Popover>
    </Box>
  );
};

export default ProfileDropdown;
